"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[4868],{

/***/ 4868:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ clearSearch)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


// Expects to find a search input as one of the previous siblings

function clearSearch({ wrapper }) {
  const selectors = {
    form: 'form',
    search: 'input[type="search"]',
  }

  const cache = {
    $form: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest(selectors.form),
    $search: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest(selectors.form).find(selectors.search),
  }

  ;(function init() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', function () {
      cache.$search.val('')
    })
  })()
}


/***/ })

}]);